import { IProductWarning, IProductWarningProps, ProductWarningType } from '../ProductWarning';

type TData = Pick<IProductWarningProps, 'type' | 'product' | 'combo'>;

export const categoryWarning = (data: TData): IProductWarning | null => {
  const { type, product, combo } = data;

  const productWithUnavailableCategory: boolean | undefined = product?.category && !product.category.status;
  const comboWithUnavailableCategory: boolean | undefined = combo?.category && !combo.category.status;

  const isUnavailable: boolean = Boolean(productWithUnavailableCategory || comboWithUnavailableCategory);

  if (isUnavailable && type === ProductWarningType.CATEGORY_IN_LIST) {
    return { message: 'item_category_is_off', maxWidth: 340 };
  }

  if (isUnavailable && type === ProductWarningType.CATEGORY_IN_EDIT_PAGE) {
    return { message: 'not_available' };
  }

  return null;
};
